export default {
  "namespaced": true,
  "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ciaone i18n !!"])}
}